import React from "react";
import { Link } from "react-router-dom";
import defaultBanner from "../../../Resources/Images/default_banner.png";
import { actionTypeContainer, generateSlug, getWidgetTitle } from "../../../Utils/utils";
import { resolveScreenBackgroundImage } from "../../../services/buscarService";

// Tarjeta de página ("screen"): extraída de los widgets list-screen/list-screen-v2
// (ListScreenComponent.js, duplicada ahí para escritorio y móvil) y list-screen-grid
// (ListScreenGridComponent.js), que antes la llevaban inline y duplicada 3 veces.
// Mismo aspecto y comportamiento en los tres sitios: se parametriza solo lo que ya
// variaba entre ellos (si se pinta el título y con qué clase, y el alt de la imagen).
const getPageId = (w) => (w?.screen?.id ? w.screen.id : w.screen);

const ScreenCard = ({
  item,
  trigger,
  contentId = null,
  turnOnLoading,
  showTitle = true,
  titleClassName = "PlaylistItemTitle ListScreenItemTitle",
  imageAlt = "",
}) => {
  const pageId = getPageId(item);
  if (!pageId) return null;

  // resolveScreenBackgroundImage acepta tanto una string plana (la forma que ya traen los
  // widgets list-screen* de la home) como el objeto anidado del contrato de /buscar
  // (`{data:{full_url,...}}`), así que esta tarjeta sirve para las dos fuentes sin adaptar
  // los datos antes de pasarlos aquí.
  const imageSrc = resolveScreenBackgroundImage(item) || defaultBanner;

  return (
    <Link
      to={`${actionTypeContainer(trigger).ROUTE}/${generateSlug(item.title)}/${pageId}`}
      onClick={() => contentId !== item.id && turnOnLoading?.()}
      className="PlaylistItem"
    >
      <div className="PlaylistItem">
        <img className="PlaylistItemImage" alt={imageAlt} aria-hidden={imageAlt ? undefined : "true"} src={imageSrc} />
        {showTitle && <div className={titleClassName}>{getWidgetTitle(item)}</div>}
      </div>
    </Link>
  );
};

export default ScreenCard;
